import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as func from "../../common/athleteCommon/FunctionCalls";
import * as api from "../../common/athleteCommon/API";
import Utils from "../../common/athleteCommon/Utils";
import Swal from "sweetalert2";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

interface Props {
    history: any;
}

const MedicalHistory: React.FC<Props> = ({ history }) => {

    // const ctgryLst = [{ ctgryId: 1, ctgryName: "Cardiovascular" }, { ctgryId: 2, ctgryName: "Respiratory" }, { ctgryId: 3, ctgryName: "Anti-inflamatory" }, { ctgryId: 4, ctgryName: "Pain Management" }, { ctgryId: 5, ctgryName: "Mental Health" }, { ctgryId: 6, ctgryName: "Harmonal" }, { ctgryId: 7, ctgryName: "Other" }]

    const [basicRecord, setBasicRecord] = useState<any>({});
    const [medCondition, setMedCondition] = useState<any[]>([]);
    const [currentMedication, setCurrentMedication] = useState<any[]>([]);
    const [allergies, setAllergies] = useState<any[]>([]);
    const [ctgryLst, setCtgryLst] = useState<any[]>([]);
    const [alrgyTypeList, setAlrgyTypeList] = useState<any[]>([]);
    const [ctgry, setCtgry] = useState("");
    const [medicalCondn, setMedicalCondn] = useState("");
    const [curMed, setCurMed] = useState("");
    const [allergy, setAllergy] = useState("");
    const [allergyName, setAllergyName] = useState("");
    const [medrow, setMedrow] = useState("");
    const [name, setName] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [addMed, setAddMed] = useState(false);
    const [addCurMed, setAddCurMed] = useState(false);
    const [addAllrgy, setAddAllrgy] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        if (history) {
            setBasicRecord(history.medicalBasicRecord || {});
            setMedCondition(history.medicalConditionRecord || []);
            setCurrentMedication(history.athleteCurrentMedicationRecord || []);
            setAllergies(history.athleteAllergiesRecord || []);
        }
        async function getMedHstry() {
            const medResponse = await func.medicationCategory(null);
            setCtgryLst(Array.isArray(medResponse) ? medResponse : []);
            const alrgyResponse = await func.allergyType(null);
            setAlrgyTypeList(Array.isArray(alrgyResponse) ? alrgyResponse : []);
        }
        getMedHstry()
    }, [history])

    const mergedData = medCondition.map(condition => {
        const medication = currentMedication.find(
            med => med.medicalProfileId === condition.medicalProfileId
        );

        const allergy = allergies.find(
            al => al.medicalProfileId === condition.medicalProfileId
        );

        return {
            medicalProfileId: condition.medicalProfileId,
            medicalCondition: condition.medicalCondition,
            currentMedication: medication?.currentMedication || "—",
            currentMedicationCtgry: medication?.category || "",
            allergies: allergy?.allergies || "—",
            allergyName: allergy?.allergyName || "—"
        };
    });

    function addMedicalCond() {
        setAddMed(true)
        setAddAllrgy(false)
        setAddCurMed(false)
        setIsEdit(false)
        setOpenModal(true)
        setName("Medical Condition")
    }

    function addCurntMedCond() {
        setAddMed(false)
        setAddAllrgy(false)
        setAddCurMed(true)
        setIsEdit(false)
        setOpenModal(true)
        setName("Current Medication")
    }

    function addAlrgy() {
        setAddMed(false)
        setAddCurMed(false)
        setAddAllrgy(true)
        setIsEdit(false)
        setOpenModal(true)
        setName("Allergy")
    }

    const editMedCond = (det: any) => {
        setAddMed(true)
        setMedicalCondn(det.medicalCondition)
        setCurMed(det.currentMedication)
        setAllergy(det.allergies);
        setMedrow(det.medicalProfileId)
        setAddAllrgy(false)
        setAddCurMed(false)
        setIsEdit(true)
        setOpenModal(true)
        setName("Medical Condition")
    }

    const editCurMedCond = (det: any) => {
        setAddMed(false)
        setMedicalCondn(det.medicalCondition)
        setCurMed(det.currentMedication)
        // setCtgry(det.currentMedicationCtgry)
        setCtgry(det.category)
        setAllergy(det.allergies);
        setMedrow(det.medicalProfileId)
        setAddAllrgy(false)
        setAddCurMed(true)
        setIsEdit(true)
        setOpenModal(true)
        setName("Current Medication")
    }

    const editAlrgy = (det: any) => {
        setAddMed(false)
        setMedicalCondn(det.medicalCondition)
        setCurMed(det.currentMedication)
        setAllergy(det.allergies);
        // setAllergyName(det.allergyName);
        setAllergyName(det.allergiesDescription);
        setMedrow(det.medicalProfileId)
        setAddAllrgy(true)
        setAddCurMed(false)
        setIsEdit(true)
        setOpenModal(true)
        setName("Allergy")
    }
    function saveMedicalCond() {
        if (isEdit) {
            updateMedCond()
        } else {
            const frmData = new FormData();
            if (name === "Medical Condition") {
                frmData.append("medicalCondition", medicalCondn);
            } else if (name === "Current Medication") {
                frmData.append("category", ctgry);
                frmData.append("currentMedication", curMed);
            } else if (name === "Allergy") {
                frmData.append("allergies", allergy);
                frmData.append("allergiesDescription", allergyName);
            }
            const injHstry = api.AddMedicalDetails;
            fetch(injHstry, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: frmData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                            .then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                    // navigate(routes.manipurlogin)
                                }
                            });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                    }
                })
        }
    }

    function updateMedCond() {
        const frmData = new FormData();
        // frmData.append("medicalCondition", medicalCondn);
        // frmData.append("allergies", allergy);
        // frmData.append("allergiesDescription", allergyName);
        // frmData.append("currentMedication", curMed);
        if (name === "Medical Condition") {
            frmData.append("medicalCondition", medicalCondn);
        } else if (name === "Current Medication") {
            frmData.append("category", ctgry);
            frmData.append("currentMedication", curMed);
        } else if (name === "Allergy") {
            frmData.append("allergies", allergy);
            frmData.append("allergiesDescription", allergyName);
        }
        const injHstry = api.EditMedicalDetails + "/" + medrow;
        fetch(injHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                        .then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                                // navigate(routes.manipurlogin)
                            }
                        });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }
    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row align-items-center">
                        <div className="d-flex text-end">
                            <Link className="dropdown-item" to="#">
                                <i className="feather-edit" />Edit
                            </Link>
                        </div>
                        <div className="row">
                            <table>
                                <tr>
                                    <th><h4 className="text-center">Blood Group:</h4></th>
                                    <td><h6>{basicRecord.bloodGroup}</h6></td>
                                    <th><h4 className="text-center">Tobacco Usage History:</h4></th>
                                    <td><h6>{basicRecord.tobacco}</h6></td>
                                    <th><h4 className="text-center">Alcohol History:</h4></th>
                                    <td><h6>{basicRecord.alcohal}</h6></td>
                                </tr>
                                <tr>
                                    <th><h4 className="text-center">Relevant Family Medical History:</h4></th>
                                    <td><h6>{basicRecord.relevantFamilyMedicalHistory}</h6></td>
                                    {/* <th><h4 className="text-center">Allergies</h4></th>
                                    <td><h6>{basicRecord.allergyName}</h6></td>
                                    <th><h4 className="text-center">Medical Condition:</h4></th>
                                    <td><h6>{basicRecord.currentMedication}</h6></td> */}
                                </tr>
                                {/* <tr>
                                    <th><h4 className="text-center">Current Medication:</h4></th>
                                    <th><h6>{basicRecord.currentMedication}</h6></th>
                                    <th><h4 className="text-center">Status:</h4></th>
                                    <td><h6>{(basicRecord.status == 1) ? "Active" : "Inactive"}</h6></td>
                                    <th></th>
                                    <td></td>
                                </tr> */}
                            </table>
                        </div>
                        <div className="row mt-4">
                            <div className="col-lg-4 table-responsive">
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th colSpan={3} className="text-center">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <span>Medical Condition</span>
                                                    <Link to="#" className="text-primary" onClick={addMedicalCond}>
                                                        <i className="feather-plus" />
                                                    </Link>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th className="text-center">Medical Condition</th>
                                            <th></th>
                                        </tr>
                                        {medCondition.length > 0 ? (
                                            medCondition.map((row: any) => (
                                                <tr key={row.medicalProfileId}>
                                                    <td className="text-center">{row.medicalCondition}</td>
                                                    <td className="text-center">
                                                        <Link to="#" className="ms-2 text-primary" onClick={() => editMedCond(row)}>
                                                            <i className="feather-edit" />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={2} className="text-center">
                                                    No medical history available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-lg-4 table-responsive">
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th colSpan={3} className="text-center">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <span>Current Medication</span>
                                                    <Link to="#" className="text-primary" onClick={addCurntMedCond}>
                                                        <i className="feather-plus" />
                                                    </Link>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th className="text-center">Medication Category</th>
                                            <th className="text-center">Current Medication</th>
                                            <th></th>
                                        </tr>
                                        {currentMedication.length > 0 ? (
                                            currentMedication.map((row: any) => (
                                                <tr key={row.medicalProfileId}>
                                                    <td className="text-center">{row.medicationCategory}</td>
                                                    <td className="text-center">{row.currentMedication}</td>
                                                    <td className="text-center">
                                                        <Link to="#" className="ms-2 text-primary" onClick={() => editCurMedCond(row)}>
                                                            <i className="feather-edit" />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={3} className="text-center">
                                                    No medical history available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-lg-4 table-responsive">
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th colSpan={3} className="text-center">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <span>Allergies</span>
                                                    <Link to="#" className="text-primary" onClick={addAlrgy}>
                                                        <i className="feather-plus" />
                                                    </Link>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th className="text-center">Allergy Name</th>
                                            <th className="text-center">Allergy Description</th>
                                            <th></th>
                                        </tr>
                                        {allergies.length > 0 ? (
                                            allergies.map((row: any) => (
                                                <tr key={row.medicalProfileId}>
                                                    <td className="text-center">{row.allergyName}</td>
                                                    <td className="text-center">{row.allergiesDescription}</td>
                                                    <td className="text-center">
                                                        <Link to="#" className="ms-2 text-primary" onClick={() => editAlrgy(row)}>
                                                            <i className="feather-edit" />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={3} className="text-center">
                                                    No medical history available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* <div className="table-responsive mt-4">
                        <table className="table table-bordered">
                            <thead className="table-light">
                                <tr>
                                    <th className="text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                            <span>Medical Condition</span>
                                            <Link to="#" className="text-primary" onClick={addMedicalCond}>
                                                <i className="feather-plus" />
                                            </Link>
                                        </div>
                                    </th>
                                    <th className="text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                            <span>Current Medication</span>
                                            <Link to="#" className="text-primary" onClick={addCurntMedCond}>
                                                <i className="feather-plus" />
                                            </Link>
                                        </div>
                                    </th>
                                    <th className="text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                            <span>Allergies</span>
                                            <Link to="#" className="text-primary" onClick={addAlrgy}>
                                                <i className="feather-plus" />
                                            </Link>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {mergedData.length > 0 ? (
                                    mergedData.map((row: any) => (
                                        <tr key={row.medicalProfileId}> */}

                    {/* Medical Condition */}
                    {/* <td>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <span>{row.medicalCondition}</span>
                                                    <Link to="#" className="ms-2 text-primary" onClick={() => editMedCond(row)}>
                                                        <i className="feather-edit" />
                                                    </Link>
                                                </div>
                                            </td> */}

                    {/* Current Medication */}
                    {/* <td className="text-center">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <span>{row.currentMedication}</span>
                                                    <Link to="#" className="ms-2 text-primary" onClick={() => editCurMedCond(row)}>
                                                        <i className="feather-edit" />
                                                    </Link>
                                                </div>
                                            </td> */}

                    {/* Allergies */}
                    {/* <td className="text-center">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <span>{row.allergyName}</span>
                                                    <Link to="#" className="ms-2 text-primary" onClick={() => editAlrgy(row)}>
                                                        <i className="feather-edit" />
                                                    </Link>
                                                </div>
                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} className="text-center">
                                            No medical history available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div> */}
                </div>
            </div>

            <Modal
                show={openModal}
                size="md"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} {name}</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    {addMed ?
                        <div className="col-lg-12">
                            <label className="form-label">Known Medical Conditions</label>
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                name="medicalCondition"
                                value={medicalCondn}
                                onChange={(e) => setMedicalCondn(e.target.value)}
                                placeholder="Enter Medical Condition" />
                        </div>
                        : null}
                    {addAllrgy ?
                        <>
                            <div className="col-lg-12">
                                <label className="form-label">Allergy Type</label>
                                <Select
                                    value={alrgyTypeList.find(alrgy => alrgy.allergyId === allergy) ? {
                                        value: allergy,
                                        label: alrgyTypeList.find(alrgy => alrgy.allergyId === allergy)?.allergyName
                                    } : null}
                                    onChange={(e) => setAllergy(e.value)}
                                    placeholder="Select Allergy Type"
                                    options={alrgyTypeList.map(alrgy => ({
                                        value: alrgy.allergyId,
                                        label: alrgy.allergyName
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-12">
                                <label className="form-label">Allergy Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    name="allergyName"
                                    value={allergyName}
                                    onChange={(e) => setAllergyName(e.target.value)}
                                    placeholder="Enter Allergy Name" />
                            </div>
                        </>
                        : null}
                    {addCurMed ?
                        <>
                            <div className="col-lg-12">
                                <label className="form-label">Category</label>
                                <Select
                                    value={ctgryLst.find(ctgory => ctgory.medicationCategoryId === ctgry) ? {
                                        value: ctgry,
                                        label: ctgryLst.find(ctgory => ctgory.medicationCategoryId === ctgry)?.name
                                    } : null}
                                    onChange={(e) => setCtgry(e.value)}
                                    placeholder="Select Category"
                                    options={ctgryLst.map(ctgory => ({
                                        value: ctgory.medicationCategoryId,
                                        label: ctgory.name
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-12">
                                <label className="form-label">Current Medications</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                    name="currentMedication"
                                    value={curMed}
                                    onChange={(e) => setCurMed(e.target.value)}
                                    placeholder="Enter Current Medication" />
                            </div>
                        </>
                        : null}
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            type="submit"
                            onClick={saveMedicalCond}
                        >
                            <b><i className="fas fa-save" />Save</b>
                        </Button>
                    </ModalFooter>
                </ModalBody>
            </Modal >
        </>
    );
};

export default MedicalHistory;